import React, { Component } from 'react';

import ClockIcon from '@assets/icons/clock-icon.svg';
import ProfileImage from '@assets/icons/default-profile-icon.svg';
import ExportIcon from '@assets/icons/import-icon.svg';
import { Row } from 'react-bootstrap';
import Papa from 'papaparse';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Tooltip from '@mui/material/Tooltip';
import './TaskDetails.css';
import Grid from '@mui/material/Grid2';
/**
 * Contains the Activity content from the {@link TaskDetails} component
 */
class TaskActivity extends Component {
  constructor(props) {
    super(props);
    let exportableData = [];
    const activityTask = this.props.taskActivity;
    if (activityTask && activityTask.length > 0) {
      for (let i = 0; i < activityTask.length; i++) {
        let userType = '';
        let userName = '';
        if (activityTask[i].agent) {
          userName = activityTask[i].agent;
          userType = this.props.lan.agent;
        } else if (activityTask[i].user) {
          userName = activityTask[i].user;
          userType = this.props.lan.user;
        }
        exportableData.push({
          hour: activityTask[i].time,
          date: activityTask[i].date,
          activity: activityTask[i].activity,
          user: userName,
          userType: userType,
        });
      }
    }
    this.state = {
      exportableData,
      activityHeaders: [
        { label: this.props.lan.hour, key: 'hour' },
        { label: this.props.lan.date, key: 'date' },
        { label: this.props.lan.activity, key: 'activity' },
        { label: this.props.lan.user, key: 'user' },
        { label: this.props.lan.type, key: 'userType' },
      ],
    };
  }
  handleExportActivity = () => {
    const { exportableData, activityHeaders } = this.state;
    const csv = Papa.unparse({
      fields: activityHeaders.map(h => h.label),
      data: exportableData.map(d => activityHeaders.map(h => d[h.key]))
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${this.props.lan.taskActivities}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
	/**
	 * Generates the user icon, username component
	 * by iterating over every user and removing repeated
	 * users
	 *
	 * @param {*} props - Image and User contained
	 */
	/**
	 * Generates the Activity Table by iterating
	 * over every element in the data found
	 *
	 * @param {*} props - Image and User contained
	 */
  ActivityTable = (props) => {
    const activityLog = props.taskActivity;
    if (!activityLog || activityLog.length === 0) return null;

    activityLog.sort((a, b) => b.idActivity - a.idActivity);
    return (
      <table className='td-activity-table'>
        <tbody>
        {activityLog.map((activity, i) => {
          let user = activity.user || activity.agent || '';
          let image = activity.userImage || ProfileImage;
          return (
            <tr key={'task-activity-' + i} style={{ height: '45px', border: '1px solid #e6ebf0' }}>
              <td className='task-activity-time-col'>
                <img src={ClockIcon} className='td-activity-table-pic mr-3 ml-3' alt='' />
                <span className='td-activity-user-text my-auto'>{activity.time}</span>
              </td>
              <td className='task-activity-date-col'>{activity.date}</td>
              <td>
                {activity.showTooltip ? (
                  <Tooltip title={activity.tooltipInfo}>
                    <div className='row'>
                      <div className='col-auto pr-0'>{activity.activity}</div>
                      <div className='col-2 no-padding'>
                        <MoreHorizIcon />
                      </div>
                    </div>
                  </Tooltip>
                ) : (
                  activity.activity
                )}
              </td>
              <td>
                <Row className='my-auto'>
                  <img src={image} className='td-activity-table-pic mr-3' alt='' />
                  <span className='td-activity-user-text td-activity-user-text-size my-auto'>
											<Tooltip title={user}>{user}</Tooltip>
										</span>
                </Row>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    );
  };
	render() {
		return (
			<Grid container direction='row' spacing={2} className='px-5'>
				<Grid size='auto'>
					<div className='label-input'>{this.props.lan.history}</div>
				</Grid>
				<Grid size='auto'>
					<img
						src={ExportIcon}
						className='icon Fielder-icon-button'
						title={this.props.lan.export}
						style={{ marginTop: '-5px' }}
						onClick={this.handleExportActivity}
            alt={"img-fielder-icon-button"}/>
				</Grid>
				<Grid size={12} >
					<this.ActivityTable taskActivity={this.props.taskActivity} />
				</Grid>
			</Grid>
		);
	}
}
export default TaskActivity;
